module.exports = require('stream-to').buffer